"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
const config = exports.config = {
  alwaysSearchOnInitialLoad: true,
  searchQuery: {
    result_fields: {
      name: {
        raw: {}
      }
    }
  },
  autocompleteQuery: {
    results: {
      resultsPerPage: 5,
      result_fields: {
        name: {
          raw: {}
        },
        url: {
          raw: {}
        }
      }
    },
    suggestions: {
      types: {
        documents: {
          fields: ['name', 'see_also'] // fields whose values can be used as suggestions
        }
      },
      size: 5
    }
  }
};